import React, { lazy, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

/** Utilities */
import { decryptUrlData, encryptUrlData } from "../../services/CryptoService";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";

/** Common Components */
import "./ProjectSynergy.scss";

/** Lazily Loaded Components */
const SynergyIdeas = lazy(() => import("./components/Ideas/SynergyIdeas"));
const UserStories = lazy(() => import("./components/userStories/UserStories"));
const ChangeRequests = lazy(() => import("./components/changeRequests/ChangeRequests"));

const ProjectSynergy = () => {

  const { id } = useParams();
  const [activeSynergyTypeID, setActiveSynergyTypeID] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  let projectId = null;
  let projectCode = '';
  let projectName = '';
  let SelectedSynergyTypeID = null;
  let selectactiveTab = 0;


  const projectdata = id ? decryptUrlData(id) : 0;
  if (typeof projectdata === 'object' && projectdata !== null) {
    projectId = projectdata.projectId;
    projectCode = projectdata?.projectCode;
    projectName = projectdata?.projectName;
    SelectedSynergyTypeID = projectdata?.SelectedSynergyTypeID
    selectactiveTab=projectdata?.activeTab
  } else if (projectdata) {
    projectId = projectdata;
    projectCode = null;
    projectName = null;
  }
  const [activeTab, setActiveTab] = useState(selectactiveTab || 0);
  const [searchText, setSearchText] = useState("");

  const addSynergy = () => {
    const dataURL = {};
    dataURL.SelectedSynergyTypeID = activeSynergyTypeID;
    dataURL.projectId = projectId;
    dataURL.projectCode = projectCode;
    dataURL.projectName = projectName;
    dataURL.activeTab=activeTab;
    const encryptedData = encryptUrlData(dataURL);
    const basePath = location.pathname.includes("/admin/project")
      ? "/admin/project/addProjectSynergy/"
      : "/myprojects/addProjectSynergy/";

    navigate(`${basePath}${encryptedData}`);
  };

  useEffect(() => {
    const fromAddPage = location.state?.fromProjectSynergy;
  
    if (fromAddPage && typeof selectactiveTab === "number") {
      setActiveTab(selectactiveTab);
      setActiveSynergyTypeID(SelectedSynergyTypeID || 1);
    } else {
      setActiveTab(0);
      setActiveSynergyTypeID(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const handleOnSearchChange = (e) => {
    let value = e.target.value;
    setSearchText(value);
  };

  const handalchangesynergyTypeID = (synergyTypeID) => {
    setActiveSynergyTypeID(synergyTypeID);
  }

  const tabs = [
    {
      sMenuItemCaption: `Ideas List`,
      icon: "",
      component: <SynergyIdeas synergyTypeID={1} handalchangesynergyTypeID={handalchangesynergyTypeID} 
      searchText={searchText}
     />,
      synergyTypeID: 1,
    },
    {
      sMenuItemCaption: "User Stories",
      icon: "",
      component: <UserStories synergyTypeID={3} handalchangesynergyTypeID={handalchangesynergyTypeID}
       searchText={searchText}
        />,
      synergyTypeID: 3,
    },
    {
      sMenuItemCaption: "Change Request List",
      icon: "",
      component: <ChangeRequests synergyTypeID={2} handalchangesynergyTypeID={handalchangesynergyTypeID}
       searchText={searchText}
       />,
      synergyTypeID: 2,
    },
  ];


  return (
    <div className="center-top-space project-synergy-tabs">
      <CardSection
        cardTitle={`${projectCode || ''} - ${projectName || ''} Project Synergy`}
        rightButton={true}
        buttonText="Add"
        titleButtonClick={addSynergy}
        buttonClassName="theme-btn"
        textWithIcon={true}
        fontIcon={true}
        iconName="material-symbols:add-rounded"
        searchInputName="Search by Synergy"
        searchInput={true}
        handleChange={handleOnSearchChange}
      >
        {/* <RenderTabs tabs={tabs}  /> */}
        <div className="row">
          <div className="col-12">
            <div className="tab-section mb-0">
              <div className="tab-header">
                {tabs.map((tab, index) => (
                  <button
                    key={index}
                    className={`tab-button ${activeTab === index ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab(index);
                      setActiveSynergyTypeID(tab.synergyTypeID);
                    }}
                  >
                    {tab.sMenuItemCaption}
                  </button>
                ))}
              </div>

              {/* Active Tab Content */}
              <div className="tab-content">
              <div className="tab-body-section">
                    {tabs[activeTab].component}
                  </div>
              </div>
            </div>
          </div>
        </div>

      </CardSection>
    </div>
  );
};

export default ProjectSynergy;
